<button
  *ngIf='canSeeLoginLogoutNotifications'
  mat-mini-fab
  class='login-logout-notification-badge'
  [matTooltip]="'MESSAGESANDWARNINGS.totalDriversToday' | translate"
  color='primary'
  vrm-bg-color
>
  <small style='position: relative; bottom: 1px'>{{ rptService.loginLogoutNotificationsCount }}</small>
</button>
